<template>
   <div class="w_main">
       <v-header></v-header>
        <div class="w_content" >
             <router-view/>
        </div>
        <v-contact></v-contact>
        <b-footer></b-footer>
   </div>
</template>
<script>
import vHeader from '@/components/header/header'
import vFooter from '@/components/footer/footer'
import vContact from '@/components/contact/contact'
import bFooter from '@/components/footer/bfooter'
export default {
    data(){  
        return {

        }
    },
    components:{
        vHeader,
        vFooter,
        vContact,
        bFooter
    }
}
</script>
<style >
div.w_content{
     background: #ffffff; 
    padding: 0px;
} 
</style>





// WEBPACK FOOTER //
// src/components/Index.vue